import React from "react";
import { Navigate } from "react-router-dom";
import { can, canAny } from "../auth/permissions";

/**
 * حماية مسار بصلاحية واحدة أو أي من عدة صلاحيات.
 * الاستخدام:
 *   <RequirePermission permission="users.view"><Page /></RequirePermission>
 *   <RequirePermission anyOf={["users.edit", "users.delete"]}><Page /></RequirePermission>
 */
export default function RequirePermission({ permission, anyOf, children, fallback = "/admin" }) {
  const allowed = Array.isArray(anyOf) && anyOf.length
    ? canAny(anyOf)
    : can(permission);

  if (!allowed) {
    return <Navigate to={fallback} replace />;
  }

  return children;
}
